import type { SxProps, Theme } from '@mui/material';

export const appliedActionsSummaryClassNames = {
  root: 'skill-applied-summary',
  icon: 'skill-applied-summary-icon',
};

export const appliedActionsSummaryStyles = {
  root: () =>
    ({
      display: 'grid',
      gridTemplateColumns: 'auto minmax(0, 1fr)',
      gap: '14px',
      width: 'min(592px, 100%)',
      border: '1px solid #62aa1c',
      borderRadius: '8px',
      padding: '12px 18px',
      background: '#edf8e5',
      color: '#539c10',
      '&.MuiPaper-root': {
        background: '#edf8e5',
      },
    }) as SxProps<Theme>,

  icon: () =>
    ({
      width: '32px',
      height: '32px',
      display: 'grid',
      placeItems: 'center',
      borderRadius: '999px',
      background: '#56a512',
      color: '#ffffff',
      '& .status-check-icon': {
        width: '25px',
        height: '25px',
      },
    }) as SxProps<Theme>,

  title: () =>
    ({
      margin: '0 0 10px',
      fontSize: '18px',
      lineHeight: 1.2,
    }) as SxProps<Theme>,

  list: () =>
    ({
      display: 'grid',
      gap: '5px',
      margin: 0,
      paddingLeft: '24px',
      fontSize: '16px',
    }) as SxProps<Theme>,
};
